// Single source of truth for how long a note may be.
//
// The Notes composer used to stop at 1,000 characters; the cap is now 2,000 and
// every note field in the app reads it from here so they can never drift apart
// again. Change this one number to change the limit everywhere.
export const NOTE_MAX_LENGTH = 2000;

// The message shown when a note field is full. Returns '' while there is room
// left, so it can be passed straight to MUI's `helperText` (and `!!` to `error`).
export const noteLimitError = (value, label = 'Note') =>
    (value || '').length >= NOTE_MAX_LENGTH
        ? `${label} cannot exceed ${NOTE_MAX_LENGTH} characters`
        : '';
